import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronLeft, FaChevronRight, FaTrash, FaEdit } from "react-icons/fa";
import { useAdmin } from "../context/adminContext";
import SummaryApi from "../common/index";
import YatraCreateForm from "../components/UpcomingYatraCart";
import AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

const s3 = new AWS.S3();

function UpcomingYatraCart() {
  const { admin } = useAdmin();
  const navigate = useNavigate();

  const [yatras, setYatras] = useState([]);
  const [currentIndexes, setCurrentIndexes] = useState([]);
  const [showCreateYatra, setShowCreateYatra] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedYatra, setSelectedYatra] = useState(null);
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [aadharCardNo, setAadharCardNo] = useState("");
  const [address, setAddress] = useState("");
  const [apang, setApang] = useState(false);
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingYatra, setEditingYatra] = useState(null);
  const [images, setImages] = useState([]);

  const [loading, setLoading] = useState(true);

  const handleFileChange = (e) => {
    setImages([...e.target.files]);
  };

  const uploadImageToS3 = async (file) => {
    const params = {
      Bucket: process.env.REACT_APP_BUCKET_NAME,
      Key: `yatra_photos/${Date.now()}_${file.name}`,
      Body: file,
      ContentType: file.type,
    };

    return new Promise((resolve, reject) => {
      s3.upload(params, (err, data) => {
        if (err) reject(err);
        else resolve(data.Location);
      });
    });
  };

  useEffect(() => {
    const fetchYatras = async () => {
      try {
        const response = await fetch(SummaryApi.getAllYatra.url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        if (Array.isArray(data)) {
          setYatras(data);
          setCurrentIndexes(data.map(() => 0));
        } else {
          console.warn("Unexpected response structure:", data);
        }
      } catch (error) {
        console.error("Error fetching yatras:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchYatras();
  }, []);

  const handlePrev = (index) => {
    setCurrentIndexes((prev) => {
      const images = yatras[index]?.imageUrls || [];
      if (images.length === 0) return prev;
      const updated = [...prev];
      updated[index] = (updated[index] - 1 + images.length) % images.length;
      return updated;
    });
  };

  const handleNext = (index) => {
    setCurrentIndexes((prev) => {
      const images = yatras[index]?.imageUrls || [];
      if (images.length === 0) return prev;
      const updated = [...prev];
      updated[index] = (updated[index] + 1) % images.length;
      return updated;
    });
  };

  const handleBookNow = (yatra) => {
    setSelectedYatra(yatra);
    setShowModal(true);
  };

  const toSlug = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[।|,|.|/#!$%^&*;:{}=\-_`~()]/g, "");

  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB").format(new Date(date));

  const resetForm = () => {
    setName("");
    setAge("");
    setMobileNo("");
    setAadharCardNo("");
    setAddress("");
    setApang(false);
    setAgreedTerms(false);
    setSelectedYatra(null);
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      name,
      age,
      mobileNo,
      aadharCardNo,
      address,
      yatraId: selectedYatra._id,
      yatraName: selectedYatra.yatraName,
      price: selectedYatra.pricePerPerson,
      apang,
      agreedTerms,
    };

    try {
      const res = await fetch(SummaryApi.createVarkari.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        alert("नोंदणी यशस्वी यशस्वी! यशस्वी");
        resetForm(); // close modal + clear fields
      } else {
        const errData = await res.json();
        alert("नोंदणी अयशस्वी: " + (errData.message || "त्रुटी आली आहे."));
      }
    } catch (err) {
      console.error("Submit error:", err);
      alert("नोंदणी अयशस्वी!");
    }
  };

  const handleDeleteYatra = async (yatraId) => {
    if (!window.confirm("खात्री आहे का? ही यात्रा कायमची हटवली जाईल.")) return;

    try {
      const res = await fetch(`${SummaryApi.deleteYatra.url}/${yatraId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.ok) {
        setYatras((prev) => prev.filter((y) => y._id !== yatraId));
        alert("यात्रा यशस्वीरित्या हटवली गेली!");
      } else {
        const errData = await res.json();
        alert("हटवता आले नाही: " + (errData.message || "त्रुटी आली आहे."));
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("यात्रा हटवता आली नाही.");
    }
  };

  const SkeletonCard = () => (
    <div className="bg-white rounded-md shadow-md animate-pulse">
      <div className="w-full h-48 bg-gray-200 rounded-t-md"></div>
      <div className="p-4">
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-2/3 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-1/4"></div>
      </div>
    </div>
  );

  return (
    <div
      className="py-14 bg-auto bg-center bg-repeat-y"
      style={{ backgroundImage: "url('/varkaripariwar_bg_photo.png')" }}
    >
      <h2 className="text-3xl md:text-4xl text-orange-800 text-center font-yatra mb-2">
        पुढील यात्रा
      </h2>
      <h2 className="text-2xl text-orange-600 font-yatra text-center mb-10">
        आपली यात्रा आपल्याला येथे बुक करता येईल.
      </h2>
      {admin && (
        <div className="text-right max-w-6xl mx-auto px-4 mb-4">
          <button
            className="bg-orange-600 hover:bg-orange-700 text-white py-2 px-4 rounded font-semibold"
            onClick={() => setShowCreateYatra(true)}
          >
            नवीन यात्रा जोडा
          </button>
        </div>
      )}

      <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6">
        {loading
          ? // Show 3 skeletons
            Array.from({ length: 3 }).map((_, index) => (
              <SkeletonCard key={index} />
            ))
          : yatras.length > 0 &&
        yatras
  .filter((yatra) => yatra.status === "upcoming")
  .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
  .map((yatra, index) => {


                const images = yatra.imageUrls || [];
                const currentImg = images[currentIndexes[index] || 0];

                return (
                  <div
                    key={yatra._id}
                    className="bg-white rounded-md shadow-xl hover:shadow-lg transition-shadow relative"
                  >
                    <div className="relative group">
                      {currentImg && (
                        <img
                          src={currentImg}
                          alt="Yatra"
                          className="w-full h-48 object-cover"
                        />
                      )}

                      {/* Delete Icon Button */}
                      {admin && (
                        <button
                          onClick={() => handleDeleteYatra(yatra._id)}
                          className="absolute top-2 right-2 bg-white/80 hover:bg-white text-red-600 p-2 rounded-full shadow-md transition-opacity opacity-0 group-hover:opacity-100"
                        >
                          <FaTrash />
                        </button>
                      )}

                      {admin && (
                        <button
                          onClick={() => {
                            setEditingYatra(yatra);
                            setShowEditModal(true);
                          }}
                          className="absolute top-2 left-2 bg-white/80 hover:bg-white text-blue-600 p-2 rounded-full shadow-md transition-opacity opacity-0 group-hover:opacity-100"
                        >
                          <FaEdit />
                        </button>
                      )}

                      {/* Previous Arrow */}
                      <button
                        onClick={() => handlePrev(index)}
                        className="hidden group-hover:flex absolute top-1/2 left-3 transform -translate-y-1/2 bg-white/70 hover:bg-white/90 p-2 rounded-full shadow-md"
                      >
                        <FaChevronLeft className="text-gray-700" />
                      </button>

                      {/* Next Arrow */}
                      <button
                        onClick={() => handleNext(index)}
                        className="hidden group-hover:flex absolute top-1/2 right-3 transform -translate-y-1/2 bg-white/70 hover:bg-white/90 p-2 rounded-full shadow-md"
                      >
                        <FaChevronRight className="text-gray-700" />
                      </button>
                    </div>

                    <div className="p-4">
                      <h3 className="text-lg font-yatra font-light text-gray-800 mb-1">
                        {yatra.yatraName}
                      </h3>
                      <hr className="border-gray-300 mb-3" />
                      <p className="text-sm mb-1">
                        <span className="text-orange-600 font-semibold">
                          प्रारंभ दिनांक:{" "}
                        </span>
                        {formatDate(yatra.startDate)}
                      </p>
                      <p className="text-sm mb-1">
                        <span className="text-orange-600 font-semibold">
                          प्रस्थान ठिकाण:{" "}
                        </span>
                        {yatra.departureLocation}
                      </p>
                      <p className="text-sm mb-1">
                        <span className="text-orange-600 font-semibold">
                          कालावधी:{" "}
                        </span>
                        {yatra.durationInDays} दिवस
                      </p>
                      <p className="text-sm mb-2">
                        <span className="text-orange-600 font-semibold">
                          प्रति व्यक्ती दर:{" "}
                        </span>
                        ₹{yatra.pricePerPerson}
                      </p>
                      <p className="text-sm mb-2">
                        <span className="text-orange-600 font-semibold">
                          अॅडव्हान्स :{" "}
                        </span>
                        ₹{yatra.bookamount}
                      </p>

                      <div className="flex justify-between mt-4">
                        <button
                          onClick={() => handleBookNow(yatra)}
                          className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold py-1 px-3 rounded"
                        >
                          बुक करा
                        </button>
                        <a
                          href="https://wa.me/919552982935"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bg-green-500 hover:bg-green-600 text-white text-sm font-semibold py-1 px-3 rounded"
                        >
                          संपर्क करा
                        </a>

                        <button
                          onClick={() =>
                            navigate(
                              `/yatra-details/${yatra._id}/${toSlug(
                                yatra.yatraName
                              )}`
                            )
                          }
                          className="bg-blue-500 hover:bg-blue-600 text-white text-sm font-semibold py-1 px-3 rounded"
                        >
                          अधिक माहिती घ्या
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
      </div>

      {/* Booking Modal */}
      {showModal && selectedYatra && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-2xl font-bold"
            >
              &times;
            </button>

            <h2 className="text-xl font-bold text-orange-700 mb-4 text-center">
              {selectedYatra.yatraName} साठी बुकिंग फॉर्म
            </h2>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 gap-4 mb-6"
            >
              <input
                type="text"
                placeholder="पूर्ण नाव"
                className="border p-2 rounded"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="number"
                placeholder="वय"
                className="border p-2 rounded"
                required
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
              <textarea
                placeholder="स्थायी पत्ता"
                className="border p-2 rounded"
                rows="2"
                required
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              <input
                type="tel"
                placeholder="मोबाईल नंबर"
                className="border p-2 rounded"
                required
                value={mobileNo}
                onChange={(e) => setMobileNo(e.target.value)}
              />
              <input
                type="text"
                placeholder="आधार कार्ड क्रमांक"
                className="border p-2 rounded"
                value={aadharCardNo}
                onChange={(e) => setAadharCardNo(e.target.value)}
              />
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={apang}
                  onChange={(e) => setApang(e.target.checked)}
                />
                अपंग आहात का?
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={agreedTerms}
                  onChange={(e) => setAgreedTerms(e.target.checked)}
                  required
                />
                मी नियम व अटी वाचल्या आहेत व मान्य करतो.
              </label>

              <div className="mb-6 text-center border border-dashed border-orange-500 p-4 rounded">
                <h3 className="text-lg font-semibold text-orange-700 mb-2">
                  कृपया ₹{selectedYatra.bookamount}
                  अ‍ॅडव्हान्स पेमेंट करा
                </h3>
                <img
                  src="/phonepay-qr.jpg"
                  alt="PhonePe QR Code"
                  className="mx-auto w-36 h-36 object-contain border border-gray-300"
                />
                <p className="text-sm text-green-600 mt-1">
                  📲 PhonePe नंबर: <span className="font-bold">9552982935</span>
                </p>
                <p className="text-sm text-gray-700 mt-2">
                  पेमेंट झाल्यानंतर कृपया स्क्रीनशॉट काढा आणि तो माझ्या WhatsApp
                  वर पाठवा. <br />
                  <span className="font-semibold text-red-600">
                    हे अनिवार्य आहे.
                  </span>{" "}
                  स्क्रीनशॉट मिळाल्यानंतरच पेमेंट मान्य करण्यात येईल.
                </p>
                <p className="text-sm text-blue-600 mt-1">
                  📞 WhatsApp नंबर:{" "}
                  <span className="font-bold">9552982935</span>
                </p>
              </div>

              <button
                type="submit"
                className="bg-orange-600 hover:bg-orange-700 text-white py-2 rounded font-bold"
              >
                सबमिट करा
              </button>
            </form>
          </div>
        </div>
      )}

      {showCreateYatra && (
        <YatraCreateForm onClose={() => setShowCreateYatra(false)} />
      )}

      {showEditModal && editingYatra && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-2xl relative max-h-[90vh] overflow-y-auto">
            <button
              onClick={() => setShowEditModal(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-2xl font-bold"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold text-orange-700 mb-4">
              यात्रा संपादित करा
            </h2>

            <form
             onSubmit={async (e) => {
  e.preventDefault();

  try {
    // Upload new images if any
    let uploadedImageUrls = [];
    if (images.length > 0) {
      const uploadPromises = images.map(uploadImageToS3);
      uploadedImageUrls = await Promise.all(uploadPromises);
    }

    // Merge old and new image URLs
    const allImageUrls = [...(editingYatra.imageUrls || []), ...uploadedImageUrls];

    const updatedYatra = {
      yatraName: editingYatra.yatraName,
      startDate: editingYatra.startDate,
      departureLocation: editingYatra.departureLocation,
      durationInDays: editingYatra.durationInDays,
      pricePerPerson: editingYatra.pricePerPerson,
      bookamount: editingYatra.bookamount,
      imageUrls: allImageUrls,
    };

    const res = await fetch(
      `${SummaryApi.updateYatra.url}/${editingYatra._id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedYatra),
      }
    );

    if (res.ok) {
      alert("यात्रा यशस्वीरित्या संपादित झाली!");
      const updatedList = yatras.map((y) =>
        y._id === editingYatra._id ? { ...y, ...updatedYatra } : y
      );
      setYatras(updatedList);
      setShowEditModal(false);
      setEditingYatra(null);
      setImages([]);
    } else {
      const errorData = await res.json();
      alert("संपादन अयशस्वी: " + errorData.message);
    }
  } catch (err) {
    console.error("Edit Error:", err);
    alert("संपादन करताना त्रुटी आली.");
  }
}}

            >
              <div>
                <label className="block text-sm font-medium mb-1">
                  फोटो अपलोड करा
                </label>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  className="w-full border px-3 py-2 rounded"
                  onChange={handleFileChange}
                />
              </div>
              <div className="mb-3">
                <label className="block text-gray-700">यात्रेचे नाव</label>
                <input
                  type="text"
                  value={editingYatra.yatraName}
                  onChange={(e) =>
                    setEditingYatra({
                      ...editingYatra,
                      yatraName: e.target.value,
                    })
                  }
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="block text-gray-700">प्रारंभ दिनांक</label>
                <input
                  type="date"
                  value={editingYatra.startDate.split("T")[0]}
                  onChange={(e) =>
                    setEditingYatra({
                      ...editingYatra,
                      startDate: e.target.value,
                    })
                  }
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="block text-gray-700">प्रस्थान ठिकाण</label>
                <input
                  type="text"
                  value={editingYatra.departureLocation}
                  onChange={(e) =>
                    setEditingYatra({
                      ...editingYatra,
                      departureLocation: e.target.value,
                    })
                  }
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="block text-gray-700">कालावधी (दिवसात)</label>
                <input
                  type="number"
                  value={editingYatra.durationInDays}
                  onChange={(e) =>
                    setEditingYatra({
                      ...editingYatra,
                      durationInDays: e.target.value,
                    })
                  }
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">
                  प्रति व्यक्ती दर (₹)
                </label>
                <input
                  type="number"
                  value={editingYatra.pricePerPerson}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setEditingYatra({
                      ...editingYatra,
                      pricePerPerson: e.target.value,
                    })
                  }
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700">अॅडव्हान्स (₹)</label>
                <input
                  type="number"
                  value={editingYatra.bookamount}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setEditingYatra({
                      ...editingYatra,
                      bookamount: e.target.value,
                    })
                  }
                  className="w-full border px-3 py-2 rounded"
                  required
                />
              </div>
              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
              >
                अपडेट करा
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default UpcomingYatraCart;
